import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { UserMembership } from 'src/features/parking/types';

const RESOURCE = '/users/:userId/memberships/';

interface DTO {
    userId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ userId }: DTO): Promise<UserMembership[]> => {
    return axios.get(formatResourcePath(RESOURCE, { userId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => {
            return await queryFn(payload);
        },
        ...config,
    });

export {
    RESOURCE as LIST_USER_MEMBERSHIPS_RESOURCE,
    queryFn as listUserMemberships,
    useQueryHook as useListUserMemberships,
};
export type { DTO as ListUserMembershipsDTO };
